import axios from 'axios';
import { ROSTER_PUBLICATION } from 'RestAPIs/endpoints';
import { RosterPublishDate } from './types';

export const getRosterPublishDate = ({ costCenters, startDate, endDate }) =>
  axios.get<RosterPublishDate>(ROSTER_PUBLICATION, {
    params: {
      costCenters,
      startDate,
      endDate
    }
  });
